const Content = {
  'people': {
    'excellence': {
      'title': 'Excellence',
      'iconName': 'trophy',
      'body': `<p><b>Excellence</b> is an unrelenting curiosity to push the limits of what’s possible in the world of content, culture and technology. The drive for preeminence touches every part of everything that we do.</p>`,
      'number': '01'
    },
    'innovation': {
      'title': 'Innovation',
      'iconName': 'light-bulb',
      'body': '<p>From our approach to problem solving, to the cutting-edge solutions we’re known for, we’re catalysts of industry disruption. <b>Innovation</b> is in our DNA.</p>',
      'number': '02'
    },
    'collaboration': {
      'title': 'Collaboration',
      'iconName': 'collaboration',
      'body': '<p>We work collectively as a team across disciplines, learning from and inspiring each other through <b>collaboration</b>. The best insights stem from diverse perspectives and deep dialogue.</p>',
      'number': '03'
    },
    'enthusiasm': {
      'title': 'Enthusiasm',
      'iconName': 'arrows-up',
      'body': '<p>We play at the intersection of creativity and science, with passion and rigor. <b>Enthusiasm</b> for what we do propels us to apply fresh thinking to big challenges.</p>',
      'number': '04'
    },
    'grit': {
      'title': 'Grit',
      'iconName': 'workout',
      'body': '<p><b>Grit</b> and confidence in our way of thinking enables us to stay ahead of fast-changing industries. We stand by the things that matter most and aren’t afraid to roll up our sleeves to realize the best results.</p>',
      'number': '05'
    }
  }
};

export { Content };
